import cx from "classnames";
import React from "react";

import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";
import Typography, { TypographyProps } from "ds/components/Typography";

import styles from "./styles.module.css";

type ViewHeaderTitleProps = {
  subtitle?: React.ReactNode;
  tag?: TypographyProps["tag"];
  children: React.ReactNode;
  tooltipDelay?: number;
  id?: string;
};

const ViewHeaderTitle = (props: ViewHeaderTitleProps) => {
  const { children, subtitle, tooltipDelay, tag = "h1", id } = props;

  const title = (
    <TextEllipsis
      tooltip={children}
      tooltipPlacement="bottom"
      tooltipWidthMode="maxWidthXl"
      delay={tooltipDelay}
    >
      {(ellipsisProps) => (
        <Typography
          {...ellipsisProps}
          className={cx(styles.title, ellipsisProps.className)}
          id={id}
          tag={tag}
        >
          {children}
        </Typography>
      )}
    </TextEllipsis>
  );

  if (!subtitle) return <>{title}</>;

  return (
    <Box>
      <div className={styles.headerTitle}>
        {title}
        <TextEllipsis
          tooltip={subtitle}
          tooltipPlacement="bottom"
          tooltipWidthMode="maxWidthXl"
          delay={tooltipDelay}
        >
          {(props) => (
            <Typography {...props} variant="p-body2" tag="p">
              {subtitle}
            </Typography>
          )}
        </TextEllipsis>
      </div>
    </Box>
  );
};

export default ViewHeaderTitle;
